<template>
  <div class="container-fluid captcha-wrapper-1">
    <div class="row align-items-center justify-content-center" v-if="captchaStatus">
      <div class="col-lg-4">
        <img :src="captcha.image" alt="captcha" class="w-75 captcha-1">
        <m-icon @click="getCaptcha()" class="d-inline-block" icon="arrow-clockwise"/>
      </div>
      <div class="col-lg-6">
        <input v-model="answer" dir="ltr" type="text" class="form-control captcha-input">
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import mIcon from '../Icons/Icon'

export default {
  name: "Captcha1",
  components: {mIcon},
  computed: {
    ...mapGetters({
      captcha: 'Captcha/getCaptcha',
      captchaStatus:"Captcha/getCaptchaStatus"
    })
  },
  data() {
    return {
      answer: ''
    }
  },
  methods: {
    getCaptcha() {
      this.$store.dispatch('Captcha/getCaptcha')
    }
  },
  mounted() {
    this.getCaptcha()
  },
  watch: {
    answer: {
      handler: async function (newValue, oldValue) {
        if (newValue != null) {
          await this.$store.dispatch('Captcha/setUserAnswer', this.answer)
          await this.$emit('update:modelValue', this.answer)
        }
      },
      deep: true
    },
  }
}
</script>

<style scoped>

</style>